import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import CurrentlyBeingServed from "../pages/Currently-being-served";

import CompletedByAnalyst from "../pages/Completed-by-analyst";
import CustomTicketsBonus from "../pages/Custom-tickets-bonus";
import CustomTickets from "../pages/Custom-tickets";
import TicketsReceived from "../pages/Tickets-received";
import BackupStatus from "../pages/BackupStatus";
import TarefasEAcessos from "../pages/TarefasEAcessos";
import AcessosRemotos from "../pages/AcessosRemotos";

import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
                <Route exact path="/currently-served" component={CurrentlyBeingServed} isPrivate />

                <Route exact path="/completed-by-analyst" component={CompletedByAnalyst} isPrivate />
                <Route exact path="/custom-tickets" component={CustomTickets} isPrivate />
                <Route exact path="/custom-tickets-bonus" component={CustomTicketsBonus} isPrivate />
                <Route exact path="/tickets-received" component={TicketsReceived} isPrivate />
                <Route exact path="/backups-status" component={BackupStatus} isPrivate />
                <Route exact path="/tarefas-customizadas" component={TarefasEAcessos} isPrivate />
                <Route exact path="/acessos-remotos" component={AcessosRemotos} isPrivate />

              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
